function imageGallery(gallery) {
    const [prev, next] = gallery.querySelectorAll('button[class*="js-gallery-nav"]');
    const imagesContainer = gallery.querySelector('.js-image-gallery-inner');
    const images = imagesContainer.querySelectorAll('.gallery-image');
    const imageWidths = [...images].map((image) => (
        image.getBoundingClientRect().width
        + parseFloat(window.getComputedStyle(images[0]).marginRight)
    ));

    let activeSlide = 0;

    next.addEventListener('click', function() {
        if (activeSlide === images.length - 1) {
            activeSlide = 0;
            imagesContainer.style.transform = 'translateX(0px)';
            return;
        };

        activeSlide += 1;

        imagesContainer.style.transform = `translateX(${imageWidths[activeSlide] * activeSlide * -1}px)`;
    });

    prev.addEventListener('click', function() {
        if (activeSlide === 0) {
            activeSlide = images.length - 1;
            imagesContainer.style.transform = `translateX(${(imageWidths.reduce((a, b) => a + b) - imageWidths[activeSlide]) * -1}px)`;
            return;
        };

        activeSlide -= 1;

        const currentTransform = Number(/(-?\d+[.\d+]?)/.exec(imagesContainer.style.transform)[1]);
        imagesContainer.style.transform = `translateX(${currentTransform + imageWidths[activeSlide]}px)`;
    });
}

export default imageGallery;